import { type ReactNode } from 'react'
import styled, { keyframes } from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

const sectionAnimation = keyframes`
  0% {
    max-height: 0;
    opacity: 0;
  }

  100% {
    max-height: 100%;
    opacity: 1;
  }
`

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${getToken('spacing-4')};
  animation: ${sectionAnimation} 500ms ease;
  width: 100%;
`

const Header = styled.header`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export type SectionProps = {
  title: string
  subtitle?: string
  actions?: ReactNode
  children: ReactNode
}

export function Section({ title, subtitle, actions, children, ...props }: SectionProps) {
  return (
    <SectionWrapper {...props}>
      <Layout.Group align="center">
        <Header>
          <Text variant="heading-md-bold">{title}</Text>
          {subtitle && <Text variant="heading-sm">{subtitle}</Text>}
        </Header>
        {actions}
      </Layout.Group>
      {children}
    </SectionWrapper>
  )
}
